<template>
  <div class="hero hero-animation hero-small" id="js-hero">
    <div class="hero-background">
      <div
        class="hero-background-image"
        style="background-image: url('img/main_visual.jpg')"
      ></div>
      <div
        class="hero-background-image-sp"
        style="background-image: url('img/main_visual_sp.jpg')"
      ></div>
    </div>
    <div class="hero-content">
      <div class="hero-content-inner">
        <div class="l-container l-container-padding-sp">
          <h1 class="hero-title">IR情報</h1>
          <div class="hero-title-sub">INVESTOR RELATIONS</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from "jquery";

export default {
  methods: {
    window: (onload = function () {
      jQuery("#js-hero").addClass("is-show");
    }),
  },
};
</script>
